import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, OnInit, Input, Inject, Output, EventEmitter } from "@angular/core";
import { TranslateService, TranslateModule, TranslatePipe } from "@ngx-translate/core";
import * as dayjs from 'dayjs';
import { ElasticsearchRepositoryService } from "../../repository/elasticsearch-repository.service";
import { ListaFormCadastroService } from "../../../common/service/lista-form-cadastro.service";
import { Template } from "../../../common/model/template";
import { ListaService } from "../../../common/service/lista.service";
import { isNull, isNullOrEmpty } from "../../../common/utils";
import { deepCopy } from "../../../common/utils/deepCopy";
import { CustomAlertService } from "../../../common/service/custom-alert.service";
import { ItemTipo, ListaTemplateItem } from "../../../common/model/lista-template-item";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ElasticsearchEditItemComponent } from '../elasticsearch-edit-item/elasticsearch-edit-item.component';

import validateJs from "validate.js";
import { IntegracaoService } from "src/app/modules/common/service/integracao.service";

@Component({
	selector: "app-elasticsearch-edit-form",
	templateUrl: "./elasticsearch-edit-form.component.html",
	styleUrls: ["./elasticsearch-edit-form.component.scss"],
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		MatIconModule,
		MatTooltipModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatButtonToggleModule,
		TranslatePipe,
		ElasticsearchEditItemComponent
	],
	providers: [
		{ useClass: ElasticsearchRepositoryService, provide: ElasticsearchRepositoryService },
		{ useClass: ListaService, provide: ListaService },
		{ useClass:ListaFormCadastroService, provide: ListaFormCadastroService},
		{ useClass: CustomAlertService, provide: CustomAlertService }
	]
})
export class ElasticsearchEditFormComponent implements OnInit {
	
	filtro: string;
	filtroObrigatoriedade: string = 'todos';

	@Input()
	tipo: number;

	@Input()
	dados: any;

	@Input()
	isEdit: boolean = false;

	@Input()
	lista: string;

	@Input()
	listaId: number;

	@Input()
	template: Template;

	@Input()
	tokenCadastroIntegracao: string;

	@Input()
	cadastroIntegracao: boolean = false;

	@Output()
    eventFechar = new EventEmitter<any>();

	public get colunas(): string[] {
		return this.template?.listaTemplateItem?.map(m => m.nome).filter(nome => nome) || [];
	}

	public get listaCamposEditaveis() {
		if (!this.template?.listaTemplateItem || this.template.listaTemplateItem.length === 0)
		{
			return null;
		}
		
		let listaItem =  this.template.listaTemplateItem.filter(f => f.ativo && (f.itemTipo == ItemTipo.Padrao || f.itemTipo == ItemTipo.Coluna) && (!this.filtro || (f.nome && f.nome.toLowerCase().indexOf(this.filtro.toLowerCase()) != -1)));

		if (this.filtroObrigatoriedade === 'obrigatorios') {
			listaItem = listaItem.filter(f => this.campoEhObrigatorio(f));
		} else if (this.filtroObrigatoriedade === 'naoObrigatorios') {
			listaItem = listaItem.filter(f => !this.campoEhObrigatorio(f));
		}

		if (this.dados?.["id"] && this.tipo != 3) {
			let identificadores: Array<string> = this.obterCamposIdentificadores();
			listaItem = listaItem.filter(f => f.ativo && !identificadores.some((s: string) => this.identificadorCorrespondeAoCampo(s, f.nome)));
		}

		if (this.cadastroIntegracao) {
			const identificadores = this.obterCamposIdentificadores();
			// Campos obrigatórios (identificadores) precisam aparecer mesmo com visivelForm falso/indefinido;
			// senão a validação exige valores que o usuário não consegue informar e o Salvar fica sempre bloqueado.
			listaItem = listaItem.filter(f =>
				f.visivelForm || identificadores.some((s: string) => this.identificadorCorrespondeAoCampo(s, f.nome))
			);
		}

		return listaItem;
	}

	public get descricaoIdentificador(): string {

		let descricao = '';

		this.obterCamposIdentificadores().forEach((campo: string) => {
			let valor = (isNullOrEmpty(this.dados[this.getPropriedade(campo)])) ? '---' : this.dados[this.getPropriedade(campo)];
			descricao += (isNullOrEmpty(descricao)) ? `${campo}: ${valor}` : ` - ${campo}: ${valor}`;
		});

		return descricao;
	}

	constructor(
		private elasticsearchRepositoryService: ElasticsearchRepositoryService,
		private listaService: ListaService,
		private translate: TranslateService,
		private integracaoService: IntegracaoService,
		private listaIntegracaoCadastroService:ListaFormCadastroService,
		private customAlertService: CustomAlertService,
	) {
		this.eventFechar = new EventEmitter<any>();
		/*this.template = data.template;
		this.lista = data.lista;
		this.tokenCadastroIntegracao = data.token;
		this.cadastroIntegracao = data.cadastroIntegracao === true ? true : false;

		if (!isNull(data.item)) {
			this.dados = deepCopy(data.item);
		}

		this.listaId = data.listaId;
		this.tipo = data.tipo;
		this.isEdit = (this.dados != null && this.dados["id"] != null);*/
	}

	obterCamposIdentificadores(): Array<string> {
		if (!this.template) {
			return [];
		}

		let identificadores: Array<string> = [];

		// Adiciona o identificador principal (identificadorAlias ou identificador)
		const identificadorPrincipal = this.template.identificadorAlias || this.template.identificador;
		if (!isNullOrEmpty(identificadorPrincipal)) {
			identificadores.push(identificadorPrincipal);
		}

		// Adiciona os identificadores de telefone se existirem
		if (!isNullOrEmpty(this.template.identificadorTelefone)) {
			const telefones = this.template.identificadorTelefone.split(',').map(t => t.trim());
			identificadores.push(...telefones);
		} else {
			// Fallback para identificadorTelefone1 e identificadorTelefone2 se identificadorTelefone não existir
			if (!isNullOrEmpty(this.template.identificadorTelefone1)) {
				identificadores.push(this.template.identificadorTelefone1);
			}
			if (!isNullOrEmpty(this.template.identificadorTelefone2)) {
				identificadores.push(this.template.identificadorTelefone2);
			}
		}

		// Remove vazios; expande "Cpf,Nome" (um único valor de configuração) em dois identificadores
		const expandidos: string[] = [];
		identificadores
			.filter(id => id && id.trim().length > 0)
			.forEach(id => {
				id.split(',')
					.map(t => t.trim())
					.filter(t => t.length > 0)
					.forEach(t => expandidos.push(t));
			});

		return expandidos.filter(
			(id, index, self) =>
				self.findIndex(x => x.toLowerCase() === id.toLowerCase()) === index
		);
	}

	ngOnInit() { }

	/** Nomes do template (identificador, telefone…) podem divergir em maiúsculas do nome da coluna na lista. */
	identificadorCorrespondeAoCampo(identificador: string, nomeCampo: string): boolean {
		if (!identificador || !nomeCampo) {
			return false;
		}
		return identificador.trim().toLowerCase() === nomeCampo.trim().toLowerCase();
	}

	campoEhObrigatorio(campo: ListaTemplateItem): boolean {
		let identificadores = this.obterCamposIdentificadores();
		if (identificadores.some((s: string) => this.identificadorCorrespondeAoCampo(s, campo.nome)))
			return true;

		if ([10, 11].some((s: number) => s == campo.listaCampoTipoId))
			return true;

		return false;
	}

	alterarValor(retorno: any) {
		if (retorno) {
			let prop = this.getPropriedade(retorno.campo.toLowerCase());
			this.dados[prop] = retorno.valor;
		}
	}

	getPropriedade(nome: string): string {
		if (!nome || this.colunas.length === 0) {
			return '';
		}
		
		let item = this.colunas.find(f => f && f.toLowerCase() == nome.toLowerCase());
		return item?.toLowerCase() || '';
	}

	desabilitaSalvar() {
		if (this.listaCamposEditaveis == null)
			return true;

		var regras: any = {};
		let identificadores: Array<string> = this.obterCamposIdentificadores();

		identificadores.forEach((campo: string) => {
			const prop = this.getPropriedade(campo);
			if (prop) {
				regras[prop] = { 'presence': { 'allowEmpty': false, 'message': '^campoObrigatorio' } };
			}
		});

		this.listaCamposEditaveis
			.filter((f: ListaTemplateItem) => [10, 11].some((s: number) => s == f.listaCampoTipoId))
			.forEach((campo: ListaTemplateItem) => {

				if (isNull(regras[this.getPropriedade(campo.nome)]))
					regras[this.getPropriedade(campo.nome)] = { 'presence': { 'allowEmpty': false, 'message': '^campoObrigatorio' } };
			});

		let validacao = validateJs.validate(this.dados, regras);
		return (!isNull(validacao));
	}

	salvar() {
		let envio: any = deepCopy(this.dados);

		this.listaCamposEditaveis?.forEach((campo: ListaTemplateItem) => {
			if (campo.listaCampoTipoId == 10)
				envio[this.getPropriedade(campo.nome)] = dayjs.default(envio[this.getPropriedade(campo.nome)]).format("DD/MM/YYYY");
		});


		if (this.isEdit && this.tipo != 3) {			
				this.integracaoService.alterarItemLista(this.listaId, this.dados["id"], envio).subscribe(
				(result: any) => { this.fechar(result); },
				(error: any) => {
					this.customAlertService.show("telaPadrao.alteracao", error.error[0], "error");
				});
		}
		else {
			if (this.cadastroIntegracao)
			{
				//nova chamada pois não precisa de autenticação nessa rota
				this.listaIntegracaoCadastroService.incluirItemLista(this.tokenCadastroIntegracao, envio).subscribe(
					(result: any) => { this.fechar(result); },
					(error: any) => {
						this.customAlertService.show("telaPadrao.erro", error.error[0], "error");
					});
			}
			else
			{
				this.integracaoService.incluirItemLista(this.listaId, envio).subscribe(
					(result: any) => { this.fechar(result); },
					(error: any) => {
						this.customAlertService.show("telaPadrao.inclusao", error.error[0], "error");
					});
			}
		}
	}

	formatElasticField(alias: any) {
		if (this.isUpperCase(alias)) return alias.toLowerCase();
		return `${alias[0].toLowerCase()}${alias.substring(1)}`;
	}

	isUpperCase(text: any) {
		return text.toUpperCase() == text;
	}

	addValorPadrao() {

		this.listaCamposEditaveis?.forEach((f: ListaTemplateItem) => {

			switch (f.alias) {
				case "Inteiro":
				case "Long":
					this.dados[this.getPropriedade(f.nome)] = Math.floor(Math.random() * 1000000) + 1;
					break;

				case "Texto":
				case "Lista":
					this.dados[this.getPropriedade(f.nome)] = "Lorem ipsum";
					break;

				case "Decimal":
					let value = (Math.random() * (1000000 - 1 + 1)) + 1;
					this.dados[this.getPropriedade(f.nome)] = Number.parseFloat(value.toString()).toFixed(2)
					break;

				case "Data":
					this.dados[this.getPropriedade(f.nome)] = new Date(+(new Date()) - Math.floor(Math.random() * 10000000000));
					break;

				case "Sim/Não":
					this.dados[this.getPropriedade(f.nome)] = true;
					break
			}

		});

	}

	fechar(s: any = null) {
		this.eventFechar.emit(s);
	}
}
